import { TableSortDirection } from 'react-magma-dom';

const getSorter = sortConfig => {
  return (a, b) => {
    const value1 = a[sortConfig.key];
    const value2 = b[sortConfig.key];

    const aValue = isNaN(value1) ? value1 : parseInt(value1, 10);
    const bValue = isNaN(value2) ? value2 : parseInt(value2, 10);

    if (aValue < bValue) {
      return sortConfig.direction === TableSortDirection.ascending
        ? -1
        : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === TableSortDirection.ascending
        ? 1
        : -1;
    }
    return 0;
  };
};

export { getSorter };
